import { render, staticRenderFns } from "./SignUpStepVerificationFail.vue?vue&type=template&id=a63c3c60"
var script = {}
import style0 from "./SignUpStepVerificationFail.vue?vue&type=style&index=0&id=a63c3c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports